import { TelemetryEventEntity } from '@src/features/order/entities';
import { TelemetryGpsInfoEntity } from '@src/features/order/entities/telemetry_gps_info';

export function normalizeGpsInfo(event: TelemetryEventEntity): TelemetryGpsInfoEntity {
  const value = (event.value ?? {}) as TelemetryGpsInfoEntity;
  const gps_status = event.gps_status ?? value.gps_status;

  if (!gps_status) {
    return value;
  }

  return {
    ...value,
    gps_status,
  };
}
